module.exports = __webpack_public_path__ + "static/teeth-67512f06107000191baaf489afb0c198.png";